<div *ngIf="show" class="form-validation">
  <ngb-alert [type]="'danger'" (close)="close()">
    <ul>
      <li *ngFor="let e of errorMessages">{{e}}</li>
    </ul>
  </ngb-alert>
</div>